export default __webpack_public_path__ + "static/media/logo.1dd050b1.png";